import { fetchJSON } from '@bonnet/next/fetch';

export default async (query) => fetchJSON('/collections/service/referenceService', { query });
